module.exports = __webpack_public_path__ + "media/images/icons/icon_check_green_light-ebc2e23db5c6fca46294b8a23ac12742.svg";